const getStyles = () => {
    return {
        container: {
        },
    };
};

export default getStyles;
